<template>
  <div v-show="$router.history.current.query.lang" class="full-page login-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- 中间 + 底部 -->
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        class="page-header header-filter"
        :class="setPageClass"
        filter-color="black"
        :style="setBgImage"
      > 
        <!-- 中间卡片 -->
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
      </div>
    </div>
    <!--弹窗 -->
    <modal v-if="smallAlertModal" @close="smallAlertModalHide">
      <template slot="header">
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="smallAlertModalHide">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="header">
        语言选择
      </template>
      <template slot="body">
        <md-button class="md-primary language_button" @click="changeLanguage('zh')">中文</md-button>
        <md-button class="md-info language_button" @click="changeLanguage('en')">English</md-button>
      </template>
    </modal>
  </div>
</template>
<style scoped>
/* 本地样式 */
  .language_button {
    margin-right: 12px;
    margin-left: 12px;
  }
</style>
<script>
import { ZoomCenterTransition } from "vue2-transitions";
import { Modal } from "@/components";
export default {
  components: {
    Modal,
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  watch:{
    '$router.history.current.query':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      host: window.location.host,
      smallAlertModal: false,
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
    };
  },
  computed: {
    setBgImage() {
      return {
        background: `#f8f8f8`,
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  methods: {
    smallAlertModalHide(){
      this.$data.smallAlertModal = false
    },
    changeLanguage(lang){
      if (lang === "zh"){
        lang = ""
      }
      this.$router.push({query: { lang }})
      this.$router.go(0)
    },


    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.header-filter::before{
  background : none !important;  
}
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
.page-header > .container{
  padding-bottom: 70px;
}
</style>
